import { render, staticRenderFns } from "./top-players-table.vue?vue&type=template&id=bd80b7f2&scoped=true&"
import script from "./top-players-table.vue?vue&type=script&lang=js&"
export * from "./top-players-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80b7f2",
  null
  
)

export default component.exports